import { ListDealAssociations, ListDealAssociationsVariables } from './__generated__/ListDealAssociations'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListDealAssociations($input: ListDealAssociationsInputV2!) {
    listDealAssociations: listDealAssociationsV2(input: $input) {
      dealAssociations {
        id
        dealId
        emailAddress
      }
      nextCursor
    }
  }
`

export const useListDealAssociations = (variables: ListDealAssociationsVariables, skip?: boolean) =>
  useQuery<ListDealAssociations, ListDealAssociationsVariables>(QUERY, {
    variables,
    skip
  })
